import React, { createContext, useContext, useState } from "react";
import { StrategyType, Strategy } from "@/types/investment";

interface InvestmentStrategyContextType {
  selectedStrategy: StrategyType | null;
  setSelectedStrategy: (strategy: StrategyType | null) => void;
  isStrategyConfirmed: boolean;
  setIsStrategyConfirmed: (confirmed: boolean) => void;
}

const InvestmentStrategyContext = createContext<InvestmentStrategyContextType | undefined>(undefined);

export function InvestmentStrategyProvider({ children }: { children: React.ReactNode }) {
  const [selectedStrategy, setSelectedStrategy] = useState<StrategyType | null>(null);
  const [isStrategyConfirmed, setIsStrategyConfirmed] = useState(false);

  return (
    <InvestmentStrategyContext.Provider
      value={{
        selectedStrategy,
        setSelectedStrategy,
        isStrategyConfirmed,
        setIsStrategyConfirmed,
      }}
    >
      {children}
    </InvestmentStrategyContext.Provider>
  );
}

export function useInvestmentStrategy() {
  const context = useContext(InvestmentStrategyContext);
  if (context === undefined) {
    throw new Error("useInvestmentStrategy must be used within an InvestmentStrategyProvider");
  }
  return context;
}

export type { StrategyType, Strategy };